var BookmarkButton    = require("app/Bookmarks/BookmarkButton"),
    IconButton        = require("app/ui/IconButton"),
    ShareButton       = require("app/Sharing/ShareButton"),
    TapCommandSupport = require("app/ui/TapCommandSupport"),
    frameThrottle     = require("enyo-perf/utils").frameThrottle,
    get               = require("object-path").get,
    icons             = require("app/theme/icons"),
    kind              = require("enyo/kind");

require("./Toolbar.less");
require("app/theme/IconButton--viewer-toolbar.less");

module.exports = kind(/** @lends  app.MediaPlayer.Tech.ImageViewer.Toolbar.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.Tech.ImageViewer.Toolbar",

    /**
     * @private
     */
    classes: "app-media-player-image-viewer-toolbar",

    /**
     * @private
     */
    isDescriptionShowing: false,

    /**
     * The state of this image.
     *
     * @type  {?Object}
     * @private
     */
    state: null,

    /**
     * @private
     */
    components: [{
        name:       "infoButton",
        kind:       IconButton,
        classes:    "app-media-player-image-viewer-toolbar__info-button",
        mixins:     [TapCommandSupport],
        theme:      "viewer-toolbar",
        tapCommand: "onRequestToggleDescription"
    }, {
        name:        "bookmarkButton",
        kind:        BookmarkButton,
        classes:     "app-media-player-image-viewer-toolbar__bookmark-button",
        theme:       "viewer-toolbar",
        showCaption: false
    }, {
        name:        "shareButton",
        kind:        ShareButton,
        classes:     "app-media-player-image-viewer-toolbar__share-button",
        theme:       "viewer-toolbar",
        showCaption: false
    }, {
        name:       "zoomOutButton",
        kind:       IconButton,
        classes:    "app-media-player-image-viewer-toolbar__zoom-out-button",
        mixins:     [TapCommandSupport],
        icon:       icons["app.MediaPlayer.ImageViewer.Toolbar.zoomOutButton"],
        theme:      "viewer-toolbar",
        tapCommand: "onRequestZoomOut"
    }, {
        name:       "zoomInButton",
        kind:       IconButton,
        classes:    "app-media-player-image-viewer-toolbar__zoom-in-button",
        mixins:     [TapCommandSupport],
        icon:       icons["app.MediaPlayer.ImageViewer.Toolbar.zoomInButton"],
        theme:      "viewer-toolbar",
        tapCommand: "onRequestZoomIn"
    }, {
        name:       "fullscreenButton",
        kind:       IconButton,
        classes:    "app-media-player-image-viewer-toolbar__fullscreen-button",
        mixins:     [TapCommandSupport],
        icon:       icons["app.MediaPlayer.ImageViewer.Toolbar.fullscreenButton"],
        theme:      "viewer-toolbar",
        tapCommand: "onRequestFullscreen"
    }, {
        name:       "exitFullscreenButton",
        kind:       IconButton,
        classes:    "app-media-player-image-viewer-toolbar__exit-fullscreen-button",
        mixins:     [TapCommandSupport],
        icon:       icons["app.MediaPlayer.ImageViewer.Toolbar.exitFullscreenButton"],
        theme:      "viewer-toolbar",
        tapCommand: "onRequestExitFullscreen"
    }],

    /**
     * @private
     */
    observers: {
        update: ["state", "isDescriptionShowing"]
    },

    /**
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
            this.fullscreenChanged();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            state       = this.state || {},
            description = get(state, "media.meta.html_long_description", null),
            $infoButton = this.$.infoButton;

        if (description) {
            if (this.get("isDescriptionShowing")) {
                $infoButton.set("tooltip", i18nService.getString("app.MediaPlayer.ImageViewer.HideDescriptionButton.tooltip"));
                $infoButton.set("icon", icons["app.MediaPlayer.ImageViewer.Toolbar.infoButton.descriptionShowing"]);
            }
            else {
                $infoButton.set("tooltip", i18nService.getString("app.MediaPlayer.ImageViewer.ShowDescriptionButton.tooltip"));
                $infoButton.set("icon", icons["app.MediaPlayer.ImageViewer.Toolbar.infoButton.descriptionHidden"]);
            }
            $infoButton.show();
        }
        else {
            $infoButton.hide();
        }

        this.$.zoomOutButton.set("tooltip", i18nService.getString("app.MediaPlayer.ImageViewer.ZoomOutButton.tooltip"));
        this.$.zoomInButton.set("tooltip", i18nService.getString("app.MediaPlayer.ImageViewer.ZoomInButton.tooltip"));

        this.$.bookmarkButton.set("mediaItem", get(state, "media", null));

        this.$.shareButton.set("mediaItem", get(state, "media", null));

        this.$.fullscreenButton.set("tooltip", i18nService.getString("app.MediaPlayer.ImageViewer.FullscreenButton.tooltip"));
        this.$.exitFullscreenButton.set("tooltip", i18nService.getString("app.MediaPlayer.ImageViewer.ExitFullscreenButton.tooltip"));

        // Toolbar needs to reflow if contents have changed
        this.resize();
    },

    /**
     * @private
     */
    fullscreenChanged: function() {
        var fullscreen = this.get("fullscreen");

        this.$.fullscreenButton.set("showing", !fullscreen);
        this.$.exitFullscreenButton.set("showing", fullscreen);
    }

});
